import { spaceCadet, ultraMarine } from '@cogneed/react-utils';
import { styled } from '@mui/material';

const StyledDiv = styled('div')(({ theme }) => ({
  '& .Collapsible__container': {
    backgroundColor: spaceCadet[100],
    borderRadius: 4,
    display: 'flex',
    flexDirection: 'column',

    '&:hover': {
      backgroundColor: ultraMarine[100],
    },

    '& .Collapsible__title': {
      cursor: 'pointer',
      position: 'relative',
      display: 'block',
      outline: 'none',
      padding: '6px 8px',
      userSelect: 'none',

      '&::before': {
        borderStyle: 'solid',
        borderColor: 'transparent',
        borderWidth: '5px 5px 0 5px',
        borderRadius: '4px',
        borderTopColor: '#000',
        display: 'block',
        content: '""',
        position: 'absolute',
        right: '15px',
        top: '50%',
        transform: 'translateY(-50%) rotate(0deg)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.standard,
        }),
      },
    },

    '& .Collapsible__content': {
      overflow: 'hidden',
      padding: '0px 8px',
      transition: theme.transitions.create('height', {
        duration: theme.transitions.duration.standard,
      }),
    },

    '&[data-lexical-is-expanded]': {
      backgroundColor: '#F2F7FF',

      '& .Collapsible__title': {
        fontWeight: 'bold',

        '&::before': {
          transform: 'translateY(-50%) rotate(180deg)',
        },
      },

      '& .Collapsible__content': {
        padding: '4px 8px',
        transition: theme.transitions.create('height', {
          duration: theme.transitions.duration.standard,
        }),
      },
    },
  },
}));

export default StyledDiv;
